import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CatchCoreModule } from '../../../modules/catch-core/catch-core.module';
import { FilterToolbarComponent } from './filter-toolbar.component';
import { BaseFilterComponent } from './base-filter/base-filter.component';
import { MoreFiltersComponent } from './more-filters/more-filters.component';

@NgModule({
  declarations: [FilterToolbarComponent, BaseFilterComponent, MoreFiltersComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, CatchCoreModule],
  exports: [FilterToolbarComponent, BaseFilterComponent, MoreFiltersComponent],
})
export class FilterToolbarModule {}
